import axiosInstance from "@/axiosConfig";
import { SUBSCRIPTION_REQUEST_ENDPOINTS } from "../configs/endpoints";
import type {
  ActivePromotionsResponse,
  SubscriptionRequestPayload,
  SubscriptionRequestResponse,
  UpsellOfferResponse,
} from "../types/subscriptionRequest.types";

export class SubscriptionRequestService {
  static async getActivePromotions(organizationId: string): Promise<ActivePromotionsResponse> {
    const url = SUBSCRIPTION_REQUEST_ENDPOINTS.ACTIVE_PROMOTIONS.replace(":organizationId", organizationId);
    const response = await axiosInstance.get<ActivePromotionsResponse>(url);
    return response.data;
  }

  static async getUpsellOffer(organizationId: string): Promise<UpsellOfferResponse> {
    const url = SUBSCRIPTION_REQUEST_ENDPOINTS.UPSELL_OFFER.replace(":organizationId", organizationId);
    const response = await axiosInstance.get<UpsellOfferResponse>(url);
    return response.data;
  }

  static async create(organizationId: string, payload: SubscriptionRequestPayload): Promise<SubscriptionRequestResponse> {
    const url = SUBSCRIPTION_REQUEST_ENDPOINTS.CREATE.replace(":organizationId", organizationId);
    const response = await axiosInstance.post<SubscriptionRequestResponse>(url, { subscription_request: payload });
    return response.data;
  }
}
